import { MeasurementSystemEnum } from '@inter-ikea-kompis/enums';
import { MeasurementUtility } from '@inter-ikea-kompis/utilities';
class SummaryPageMeasurementUtility {
    /**
     * @param translations Translations from the translations service.
     * @param settings DEXF settings retrieved from settings service.
     * @param locale Locale in format xx-XX, e.g., en-GB.
     * @param measurements The measurements.
     * @param useLongFormat Use a long (three rows) format with labels.
     * @param measurementSystem  Override market setting "useMetricMeasures" by controlling the measurement system in the planner.
     * @returns Formatted and localized measurement row(s) with the correct unit (cm/inches).
     */
    static getLocalizedMeasurementRows(translations, settings, locale, measurements, useLongFormat = false, measurementSystem = null) {
        const localisation = settings.localisation;
        const { measureValueCm, measureValueIn } = translations;
        let convertedMeasurements = {};
        let unit = '';
        if (measurementSystem === MeasurementSystemEnum.metric) {
            convertedMeasurements = this.getMetricMeasures(measurements, locale);
            unit = measureValueCm;
        }
        else if (measurementSystem === MeasurementSystemEnum.imperial) {
            convertedMeasurements = this.getImperialMeasures(measurements);
            unit = measureValueIn;
        }
        else {
            if (localisation.useMetricMeasures) {
                convertedMeasurements = this.getMetricMeasures(measurements, locale);
                unit = measureValueCm;
            }
            else {
                convertedMeasurements = this.getImperialMeasures(measurements);
                unit = measureValueIn;
            }
        }
        if (useLongFormat) {
            const { labelHeight, labelWidth, labelDepth } = translations;
            return [
                `${labelHeight} ${convertedMeasurements.height} ${unit}`,
                `${labelWidth} ${convertedMeasurements.width} ${unit}`,
                `${labelDepth} ${convertedMeasurements.depth} ${unit}`
            ];
        }
        else {
            return [
                `${convertedMeasurements.width}x${convertedMeasurements.depth}x${convertedMeasurements.height} ${unit}`
            ];
        }
    }
}
SummaryPageMeasurementUtility.getMetricMeasures = (measurements, locale) => {
    return Object.fromEntries(Object.entries(measurements).map(([dimension, millimeter]) => {
        const millimeterToCm = Math.round(millimeter) / 10;
        const toLocaleCm = millimeterToCm.toLocaleString(locale);
        return [dimension, toLocaleCm];
    }));
};
SummaryPageMeasurementUtility.getImperialMeasures = (measurements) => {
    return Object.fromEntries(Object.entries(measurements).map(([dimension, millimeter]) => {
        const toLocaleIn = MeasurementUtility.metricToImperial(millimeter, false, true);
        return [dimension, toLocaleIn];
    }));
};
export default SummaryPageMeasurementUtility;
//# sourceMappingURL=SummaryPageMeasurementUtility.js.map